import { ArrowRight } from "lucide-react"

export default function HowItWorks() {
  const steps = [
    {
      number: "01",
      title: "Create Your Profile",
      description: "Sign up and enter your gaming details or connect your Valorant account directly.",
    },
    {
      number: "02",
      title: "Set Your Preferences",
      description: "Choose your desired teammate skill level, playstyle, and communication preferences.",
    },
    {
      number: "03",
      title: "Get Matched",
      description: "Our AI analyzes your profile and finds the perfect teammates for your gaming style.",
    },
    {
      number: "04",
      title: "Squad Up & Dominate",
      description: "Connect with your new teammates, join voice chat, and start winning together.",
    },
  ]

  return (
    <section className="container mx-auto px-4 py-20">
      <div className="text-center mb-16">
        <h2 className="text-3xl md:text-4xl font-bold mb-4">How FragNades Works</h2>
        <p className="text-zinc-400 max-w-2xl mx-auto">
          Finding your perfect squad is easy with our streamlined process.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
        {steps.map((step, index) => (
          <div key={index} className="relative">
            <div className="bg-zinc-800/50 backdrop-blur-sm rounded-lg p-6 border border-zinc-700 h-full">
              <div className="text-3xl font-bold text-red-500 mb-4">{step.number}</div>
              <h3 className="text-xl font-bold mb-2">{step.title}</h3>
              <p className="text-zinc-400">{step.description}</p>
            </div>

            {index < steps.length - 1 && (
              <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
                <ArrowRight className="h-6 w-6 text-red-500" />
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  )
}

